export const ORBIT_ACCOUNT_LOOKUP_DEBOUNCE_MS = 500;
export const ORBIT_ACCOUNT_MIN_DOCUMENT_LENGTH = 5;
